import { render } from "./ContatoIndex.vue?vue&type=template&id=0f4fa206&scoped=true&ts=true"
import script from "./ContatoIndex.vue?vue&type=script&lang=ts"
export * from "./ContatoIndex.vue?vue&type=script&lang=ts"

import "./ContatoIndex.vue?vue&type=style&index=0&id=0f4fa206&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4fa206"]])

export default __exports__